import { render, staticRenderFns } from "./CardConfirmacaoEnvioEmMassa.vue?vue&type=template&id=2a80d130&scoped=true"
import script from "./CardConfirmacaoEnvioEmMassa.vue?vue&type=script&lang=js"
export * from "./CardConfirmacaoEnvioEmMassa.vue?vue&type=script&lang=js"
import style0 from "./CardConfirmacaoEnvioEmMassa.vue?vue&type=style&index=0&id=2a80d130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80d130",
  null
  
)

export default component.exports